function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m299.390625 43.390625h-8.679687c-16.773438 0-30.371094-13.597656-30.371094-30.375v-4.335937c0-4.792969-3.886719-8.679688-8.679688-8.679688-4.792968 0-8.675781 3.886719-8.675781 8.679688v4.335937c.027344 26.347656 21.378906 47.703125 47.726563 47.730469h8.679687c16.773437 0 30.371094 13.597656 30.371094 30.371094 0 16.777343-13.597657 30.375-30.371094 30.375h-8.679687c-26.347657.027343-47.699219 21.378906-47.726563 47.726562v47.730469c0 4.792969 3.882813 8.679687 8.675781 8.679687 4.792969 0 8.679688-3.886718 8.679688-8.679687v-47.730469c0-16.773438 13.597656-30.371094 30.371094-30.371094h8.679687c26.359375 0 47.726563-21.367187 47.726563-47.730468 0-26.359376-21.367188-47.726563-47.726563-47.726563zm0 0",
  fill: "#3a3e48"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m19.378906 311.417969c-11.046875 34.039062-17.5625 69.382812-19.378906 105.125 0 86.777343 8.679688 95.457031 43.390625 95.457031 83.308594 0 60.882813-85.910156 99.960937-107.78125l64.71875-5.03125h87.179688l64.722656 5.03125c39.074219 21.871094 16.652344 107.78125 99.960938 107.78125 34.710937 0 43.386718-8.679688 43.386718-95.457031-1.816406-35.742188-8.332031-71.085938-19.375-105.125l-32.449218-76.246094c-13.136719-21.417969-28.011719-35.578125-43.632813-35.578125-34.710937 0-26.03125 17.355469-95.457031 17.355469h-121.492188c-69.421874 0-60.746093-17.355469-95.457031-17.355469-15.621093 0-30.492187 14.160156-43.632812 35.578125zm0 0",
  fill: "#586270"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m216.949219 373.152344c0 23.964844-19.425781 43.390625-43.390625 43.390625-23.960938 0-43.390625-19.425781-43.390625-43.390625s19.429687-43.390625 43.390625-43.390625c23.964844 0 43.390625 19.425781 43.390625 43.390625zm0 0",
  fill: "#3a3e48"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m373.152344 373.152344c0 23.964844-19.425782 43.390625-43.390625 43.390625-23.960938 0-43.390625-19.425781-43.390625-43.390625s19.429687-43.390625 43.390625-43.390625c23.964843 0 43.390625 19.425781 43.390625 43.390625zm0 0",
  fill: "#3a3e48"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m208.269531 373.152344c0 19.171875-15.539062 34.710937-34.710937 34.710937s-34.710938-15.539062-34.710938-34.710937 15.539063-34.710938 34.710938-34.710938 34.710937 15.539063 34.710937 34.710938zm0 0",
  fill: "#586270"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m364.472656 373.152344c0 19.171875-15.539062 34.710937-34.710937 34.710937-19.167969 0-34.710938-15.539062-34.710938-34.710937s15.542969-34.710938 34.710938-34.710938c19.171875 0 34.710937 15.539063 34.710937 34.710938zm0 0",
  fill: "#586270"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m156.203125 295.050781c.101563 36.726563-28.421875 67.179688-65.078125 69.480469s-68.757812-24.347656-73.25-60.800781c-.691406-5.765625-.691406-11.59375 0-17.359375 4.492188-36.453125 36.59375-63.101563 73.25-60.800782 36.65625 2.300782 65.179688 32.753907 65.078125 69.480469zm0 0",
  fill: "#3a3e48"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m485.964844 295.050781c0 38.339844-31.082032 69.421875-69.421875 69.421875-38.34375 0-69.425781-31.082031-69.425781-69.421875 0-38.339843 31.082031-69.421875 69.425781-69.421875 38.339843 0 69.421875 31.082032 69.421875 69.421875zm0 0",
  fill: "#3a3e48"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m390.507812 295.050781c0 11.980469-9.710937 21.695313-21.695312 21.695313-11.980469 0-21.695312-9.714844-21.695312-21.695313s9.714843-21.695312 21.695312-21.695312c11.984375 0 21.695312 9.714843 21.695312 21.695312zm0 0",
  fill: "#ff6c77"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m438.238281 247.320312c0 11.984376-9.714843 21.695313-21.695312 21.695313s-21.695313-9.710937-21.695313-21.695313c0-11.980468 9.714844-21.691406 21.695313-21.691406s21.695312 9.710938 21.695312 21.691406zm0 0",
  fill: "#5dc382"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m485.964844 295.050781c0 11.980469-9.710938 21.695313-21.695313 21.695313-11.980469 0-21.691406-9.714844-21.691406-21.695313s9.710937-21.695312 21.691406-21.695312c11.984375 0 21.695313 9.714843 21.695313 21.695312zm0 0",
  fill: "#d8625e"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m438.238281 342.78125c0 11.980469-9.714843 21.691406-21.695312 21.691406s-21.695313-9.710937-21.695313-21.691406c0-11.984375 9.714844-21.695312 21.695313-21.695312s21.695312 9.710937 21.695312 21.695312zm0 0",
  fill: "#5496ce"
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  fill: "#586270"
}, /*#__PURE__*/React.createElement("path", {
  d: "m86.78125 277.695312c-4.792969 0-8.679688-3.886718-8.679688-8.679687v-43.386719c0-4.792968 3.886719-8.679687 8.679688-8.679687s8.675781 3.886719 8.675781 8.679687v43.386719c0 4.792969-3.882812 8.679687-8.675781 8.679687zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m60.746094 295.050781c0 4.792969-3.886719 8.679688-8.679688 8.679688h-34.191406c-.691406-5.765625-.691406-11.59375 0-17.359375h34.191406c4.792969 0 8.679688 3.886718 8.679688 8.679687zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m156.203125 303.730469h-34.710937c-4.792969 0-8.679688-3.886719-8.679688-8.679688s3.886719-8.679687 8.679688-8.679687h34.710937c4.792969 0 8.679687 3.886718 8.679687 8.679687s-3.886718 8.679688-8.679687 8.679688zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m86.78125 373.152344c-4.792969 0-8.679688-3.886719-8.679688-8.679688v-34.710937c0-4.792969 3.886719-8.675781 8.679688-8.675781s8.675781 3.882812 8.675781 8.675781v34.710937c0 4.792969-3.882812 8.679688-8.675781 8.679688zm0 0"
}));

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m190.914062 216.949219h121.492188v60.746093c0 9.585938-7.769531 17.355469-17.355469 17.355469h-86.78125c-9.582031 0-17.355469-7.769531-17.355469-17.355469zm0 0",
  fill: "#a5b4b4"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m86.78125 173.558594c-4.792969 0-8.679688-3.882813-8.679688-8.675782v-17.355468c0-4.792969 3.886719-8.679688 8.679688-8.679688s8.675781 3.886719 8.675781 8.679688v17.355468c0 4.792969-3.882812 8.675782-8.675781 8.675782zm0 0",
  fill: "#ed634c"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m52.066406 190.914062c-1.34375 0-2.667968-.3125-3.867187-.910156l-17.359375-8.679687c-4.289063-2.140625-6.027344-7.355469-3.886719-11.644531 2.144531-4.289063 7.355469-6.03125 11.644531-3.886719l17.359375 8.675781c3.605469 1.800781 5.5 5.84375 4.574219 9.765625-.929688 3.921875-4.433594 6.6875-8.464844 6.679687zm0 0",
  fill: "#ed634c"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m416.542969 173.558594c-4.792969 0-8.679688-3.882813-8.679688-8.675782v-17.355468c0-4.792969 3.886719-8.679688 8.679688-8.679688s8.675781 3.886719 8.675781 8.679688v17.355468c0 4.792969-3.882812 8.675782-8.675781 8.675782zm0 0",
  fill: "#ed634c"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "m451.253906 190.914062c-4.03125.007813-7.535156-2.757812-8.460937-6.679687-.929688-3.921875.964843-7.964844 4.574219-9.765625l17.355468-8.675781c4.289063-2.144531 9.503906-.402344 11.644532 3.886719 2.144531 4.289062.402343 9.503906-3.886719 11.644531l-17.355469 8.679687c-1.203125.597656-2.527344.910156-3.871094.910156zm0 0",
  fill: "#ed634c"
});

var SvgPlaystation = function SvgPlaystation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-4 0 512 512",
    width: "512pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlaystation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/playstation.f17f271e.svg";
export { ForwardRef as ReactComponent };